module.exports = __webpack_public_path__ + "img/index_beess@2x.53cfb01e.png";